<div mat-dialog-title>
    @switch(data.action) {

        @case (action.Copy) {
            <mat-icon class="accent spin">folder_copy</mat-icon> {{ 'toCopy' | translate }}
        }

        @default {
            <mat-icon class="warn-icon spin">delete_outline</mat-icon> {{ 'toDelete' | translate }}
        }
    }

</div>
<mat-dialog-content>
    {{ data.message | translate }}
    @if(data.action===action.Delete){
        <mat-checkbox (change)="save($event.checked)">{{ 'noAskMeAgain' | translate }}</mat-checkbox>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button matButton="tonal" [mat-dialog-close]="false" data-cy="confirm-cancel-btn">
        <mat-icon>cancel</mat-icon>{{ 'cancel' | translate }}
    </button>

    @switch(data.action) {

        @case (action.Copy) {
            <button matButton="tonal" [mat-dialog-close]="true" data-cy="confirm-ok-btn" class="accent">
                <mat-icon>folder_copy</mat-icon>{{ 'copy' | translate }}
            </button>
        }

        @default {
            <button matButton="tonal" [mat-dialog-close]="true" data-cy="confirm-ok-btn" class="warn">
                <mat-icon>delete_outline</mat-icon>{{ 'delete' | translate }}
            </button>
        }
    }

</mat-dialog-actions>